import { Activity, Occasion } from '@oskarjiang/matchi-types';
import { FilterState, hasActiveBypassFilters } from './filterConfig';
import { FILTER_FUNCTIONS, filterMinLevel } from './filterFunctions';

/**
 * Applies all configured filters to a list of occasions
 * @param occasions - The occasions to filter
 * @param activities - All available activities (for lookup)
 * @param state - Current filter state
 * @returns Filtered list of occasions
 */
export const applyFilters = (occasions: Occasion[], activities: Activity[] | undefined, state: FilterState): Occasion[] => {
	return occasions.filter((occasion) => {
		const relatedActivity = activities?.find((activity) => activity.id === occasion.activityId);

		// Apply each filter function in sequence
		for (const filterFn of FILTER_FUNCTIONS) {
			// Skip minLevel filter if bypass filters are active
			if (filterFn === filterMinLevel && hasActiveBypassFilters(state)) {
				continue;
			}

			if (!filterFn(occasion, relatedActivity, state)) {
				return false;
			}
		}

		return true;
	});
};
